'use client'
import { memo, useRef, type FC } from 'react'
import styled from 'styled-components'
import { Img } from '../../base'
import { getIcon } from '@/utils'
import { mq, vw } from '@/styles'
import { motion, useScroll, useSpring, useTransform } from 'motion/react'

export const FlyingPastaSvg:FC = memo(({  }) => {
  const containerRef = useRef(null)

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'start start']
  })

  const spring = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  })

  const translateYLeft = useTransform(spring, [0, 1], [-250, 0])
  const translateXLeft = useTransform(spring, [0, 1], [70, -180])
  const translateYRight = useTransform(spring, [0, 1], [-340, -120])
  const translateXRight = useTransform(spring, [0, 1], [-200, 250])

  return (
    <Div>
      <PastaWrapper ref={containerRef} className='pasta-wrapper'>
        <ImageOverlay style={{ translateY: translateYLeft, translateX: translateXLeft }} className='bestseller-left'>
          <Img media={getIcon('pasta-left')}/>
        </ImageOverlay>
        <ImageOverlay style={{ translateY: translateYRight, translateX: translateXRight }} className='bestseller-right'>
          <Img media={getIcon('pasta-right')}/>
        </ImageOverlay>
      </PastaWrapper>
    </Div>
  )
})

const PastaWrapper = styled.div`
  height: ${vw(882, 'mobile')};
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  transform: translateY(-17%);
  user-select: none;
  z-index: 2;

  ${mq.greaterThan('tablet')} {
    height: ${vw(1356, 'desktop')};
    transform: translateY(-8%);
  }
`

const Div = styled.div`
	position: initial;
`


const ImageOverlay = styled(motion.div)`
  z-index: 1;
  position: absolute;
  user-select: none;
  pointer-events: none;

  &.bestseller-left {
    left: ${vw(-130, 'mobile')};
    top: ${vw(650, 'mobile')};

    img {
      height: ${vw(418, 'mobile')};
      width: ${vw(240, 'mobile')};
    }
  }

  &.bestseller-right {
    right: ${vw(-110, 'mobile')};
    top: ${vw(380, 'mobile')};

    img {
      height: ${vw(391, 'mobile')};
      width: ${vw(288, 'mobile')};
    }
  }

  ${mq.greaterThan('tablet')} {
    &.bestseller-left {
      left: ${vw(-120, 'desktop')};
      top: ${vw(685, 'desktop')};

      img {
        height: ${vw(844, 'desktop')};
        width: ${vw(507, 'desktop')};
      }
    }

    &.bestseller-right {
      right: ${vw(-70, 'desktop')};
      top: ${vw(487, 'desktop')};

      img {
        height: ${vw(690, 'desktop')};
        width: ${vw(621, 'desktop')};
      }
    }
  }
`
